import { GeneralStatus } from 'enums/status';
import { ChecklistFieldTypes, ChecklistTypes, FrequencyTypes } from 'enums/types';

export const vehicle = {
  name: '',
  weekDays: [],
  fields: [
    {
      name: 'Imagens do Veículo',
      type: ChecklistFieldTypes.VehicleImage,
      active: true,
      inputs: [
        {
          label: 'Visão Lateral Esquerda',
        },
        {
          label: 'Visão Frontal',
        },
        {
          label: 'Visão Lateral Direita',
        },
        {
          label: 'Visão Traseira',
        },
      ],
      description: 'Fotografias do veículo nas seguintes vistas.',
    },
    {
      name: 'Avarias',
      type: ChecklistFieldTypes.Breakdowns,
      active: true,
      description: 'Fotografias das avarias no veículo',
    },
    {
      name: 'Outros Registros',
      type: ChecklistFieldTypes.Image,
      active: true,
      inputs: [
        {
          label: 'Nome do item',
        },
      ],
      description: 'Fotografias dos itens abaixo',
    },
    {
      name: 'Itens Básicos',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Chave de Roda',
          active: false,
        },
        {
          label: 'Macaco',
          active: false,
        },
        {
          label: 'Triângulo',
          active: false,
        },
        {
          label: 'Limpador de Para-Brisa',
          active: false,
        },
        {
          label: 'Estepe',
          active: false,
        },
        {
          label: 'Documento',
          active: false,
        },
        {
          label: 'Cartão-combustível',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Itens Complementares',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Manual',
          active: false,
        },
        {
          label: 'Tapete',
          active: false,
        },
        {
          label: 'Calota',
          active: false,
        },
        {
          label: 'Chave Reserva',
          active: false,
        },
        {
          label: 'TAG de Pedágio',
          active: false,
        },
        {
          label: 'Guia de Referência',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Funcionamento dos Itens Obrigatórios',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Setas dianteiras',
          active: false,
        },
        {
          label: 'Setas traseiras',
          active: false,
        },
        {
          label: 'Farolete',
          active: false,
        },
        {
          label: 'Farol',
          active: false,
        },
        {
          label: 'Lanterna Traseira',
          active: false,
        },
        {
          label: 'Luz de Freio',
          active: false,
        },
        {
          label: 'Buzina',
          active: false,
        },
        {
          label: 'Motor',
          active: false,
        },
      ],
      options: ['SIM', 'NÃO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Normatização/Legislação',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Pop de Transporte',
          active: false,
        },
        {
          label: 'Licença Ambiental',
          active: false,
        },
        {
          label: 'Alvará Sanitário',
          active: false,
        },
        {
          label: 'Ficha de Emergência',
          active: false,
        },
        {
          label: 'Painel de Risco',
          active: false,
        },
      ],
      options: ['SIM', 'NÃO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'E.P.C. (Equipamentos de Proteção Coletivo)',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Kit de Contigência (derramamento)',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'E.P.I (Equipamentos de Proteção Individual)',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Álcool Gel',
          active: false,
        },
        {
          label: 'Máscara de Proteção Individual',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Pneus',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Dianteiros',
          active: false,
        },
        {
          label: 'Traseiros',
          active: false,
        },
        {
          label: 'Estepe',
          active: false,
        },
      ],
      options: ['RUINS', 'MEIA-VIDA', 'BONS'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Níveis',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Nível do Óleo',
          active: false,
        },
        {
          label: 'Nível Água Radiador',
          active: false,
        },
      ],
      options: ['MÍNIMO', 'NORMAL', 'MÁXIMO'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Limpeza do Veículo',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Interno',
          active: false,
        },
        {
          label: 'Externo',
          active: false,
        },
        {
          label: 'Compartimento de Carga',
          active: false,
        },
      ],
      options: ['LIMPO', 'SUJO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
  ],
  type: ChecklistTypes.Vehicles,
  frequency: FrequencyTypes.Single,
  status: GeneralStatus.Active,
};
export const motorcycle = {
  name: '',
  weekDays: [],
  fields: [
    {
      name: 'Imagens do Veículo',
      type: ChecklistFieldTypes.VehicleImage,
      active: false,
      inputs: [
        {
          label: 'Visão Lateral Esquerda',
        },
        {
          label: 'Visão Frontal',
        },
        {
          label: 'Visão Lateral Direita',
        },
        {
          label: 'Visão Traseira',
        },
      ],
      description: 'Fotografias do veículo nas seguintes vistas.',
    },
    {
      name: 'Avarias',
      type: ChecklistFieldTypes.Breakdowns,
      active: false,
      description: 'Fotografias das avarias no veículo',
    },
    {
      name: 'Outros Registros',
      type: ChecklistFieldTypes.Image,
      active: false,
      inputs: [
        {
          label: 'Nome do item',
        },
      ],
      description: 'Fotografias dos itens abaixo',
    },
    {
      name: 'Itens Básicos',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Baú',
          active: false,
        },
        {
          label: 'Documento',
          active: false,
        },
        {
          label: 'Cartão-combustível',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Itens Complementares',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Manual',
          active: false,
        },
        {
          label: 'TAG de Pedágio',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Funcionamento dos Itens Obrigatórios',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Setas dianteiras',
          active: false,
        },
        {
          label: 'Setas traseiras',
          active: false,
        },
        {
          label: 'Farolete',
          active: false,
        },
        {
          label: 'Farol',
          active: false,
        },
        {
          label: 'Lanterna Traseira',
          active: false,
        },
        {
          label: 'Luz de Freio',
          active: false,
        },
        {
          label: 'Buzina',
          active: false,
        },
        {
          label: 'Motor',
          active: false,
        },
      ],
      options: ['SIM', 'NÃO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Normatização/Legislação',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Pop de Transporte',
          active: false,
        },
        {
          label: 'Licença Ambiental',
          active: false,
        },
        {
          label: 'Alvará Sanitário',
          active: false,
        },
        {
          label: 'Ficha de Emergência',
          active: false,
        },
        {
          label: 'Painel de Risco',
          active: false,
        },
      ],
      options: ['SIM', 'NÃO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'E.P.C. (Equipamentos de Proteção Coletivo)',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Kit de Contigência (derramamento)',
          active: false,
        },
        {
          label: 'Protetor Motor',
          active: false,
        },
        {
          label: 'Corta Pipa',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'E.P.I (Equipamentos de Proteção Individual)',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Protetor Auricular',
          active: false,
        },
        {
          label: 'Luva',
          active: false,
        },
        {
          label: 'Colete de Sinalização',
          active: false,
        },
        {
          label: 'Capacete',
          active: false,
        },
        {
          label: 'Jaqueta',
          active: false,
        },
        {
          label: 'Luva',
          active: false,
        },
        {
          label: 'Colete Reflexivo',
          active: false,
        },
        {
          label: 'Joelheira',
          active: false,
        },
        {
          label: 'Antena Corta-Pipa',
          active: false,
        },
      ],
      options: ['PRESENTE', 'AUSENTE', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Pneus',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Dianteiros',
          active: false,
        },
        {
          label: 'Traseiros',
          active: false,
        },
      ],
      options: ['RUINS', 'MEIA-VIDA', 'BONS'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Níveis',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Nível do Óleo',
          active: false,
        },
      ],
      options: ['MÍNIMO', 'NORMAL', 'MÁXIMO'],
      description: 'Checagem dos seguintes itens no veículo',
    },
    {
      name: 'Limpeza do Veículo',
      type: ChecklistFieldTypes.Checkbox,
      active: false,
      inputs: [
        {
          label: 'Externo',
          active: false,
        },
        {
          label: 'Baú',
          active: false,
        },
      ],
      options: ['LIMPO', 'SUJO', 'NÃO SE APLICA'],
      description: 'Checagem dos seguintes itens no veículo',
    },
  ],
  type: ChecklistTypes.Motorcycle,
  frequency: FrequencyTypes.Single,
  status: GeneralStatus.Active,
};

export const checklistBase = {
  [ChecklistTypes.Vehicles]: vehicle,
  [ChecklistTypes.Motorcycle]: motorcycle,
};

export const IMAGE_PLACEHOLDER = '/images/image-placeholder.png';
